import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Wrapper from "../../UI/Wrapper";
import axios from "axios";
import { DateRangePicker } from "react-date-range";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const MapComponent = () => {
  const [cityData, setCityData] = useState([]);
  const [serviceTypeData, setServiceTypeData] = useState([]);
  const [dateRangeCity, setdateRangeCity] = useState("Select Date Range");
  const [isCityLeadDataOpen, setisCityLeadDataOpen] = useState(false);
  const [selectionRangeCity, setselectionRangeCity] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [loading, setLoading] = useState(false);

  const baseAPI = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchGraphData = async () => {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      try {
        const response = await axios.get(
          `${baseAPI}userget/GetUsersCityData?serviceType=${serviceTypeData}&startdate=&enddate=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        if (response) {
          setCityData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching user detail:", error);
      }
    };

    fetchGraphData();
  }, [serviceTypeData]);

  const handleServiceTypeChange = (event) => {
    setServiceTypeData(event.target.value);
  };

  const toggleRegionFilter = () => {
    setisCityLeadDataOpen(!isCityLeadDataOpen);
  };

  const handleSelectleadUser = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setselectionRangeCity({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const cityFilterApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = selectionRangeCity.startDate
      ? formatDate(selectionRangeCity.startDate)
      : "";
    let enddate = selectionRangeCity.endDate
      ? formatDate(selectionRangeCity.endDate)
      : "";

    if (startdate && enddate) {
      setdateRangeCity(startdate + " - " + enddate);
    } else {
      setdateRangeCity("Select Date Range");
    }

    if (storedToken) {
      setLoading(true);
      axios
        .get(
          `${baseAPI}userget/GetUsersCityData?serviceType=${serviceTypeData}&startdate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response) {
            setCityData(response.data.data);
            setisCityLeadDataOpen(!isCityLeadDataOpen);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const closeButtonCityData = () => {
    setisCityLeadDataOpen(!isCityLeadDataOpen);
  };

  // const geoJsonData = {
  //   type: "FeatureCollection",
  //   features: [
  //     {
  //       type: "Feature",
  //       properties: { name: "Country 1" },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [11.25, 43.78],
  //             [11.25, 45.0],
  //             [13.17, 45.0],
  //             [13.17, 43.78],
  //             [11.25, 43.78],
  //           ],
  //         ],
  //       },
  //     },
  //     {
  //       type: "Feature",
  //       properties: { name: "Country 2" },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [-74.0, 40.7],
  //             [-74.0, 41.0],
  //             [-73.8, 41.0],
  //             [-73.8, 40.7],
  //             [-74.0, 40.7],
  //           ],
  //         ],
  //       },
  //     },
  //     // Add more countries with their coordinates
  //   ],
  // };

  // const geoJsonStyle = {
  //   fillColor: "#ccc",
  //   weight: 1,
  //   opacity: 1,
  //   color: "white",
  //   dashArray: "3",
  //   fillOpacity: 0.7,
  // };

  // const onCountryHover = (event) => {
  //   const countryName = event.target.feature.properties.name;
  //   console.log("Hovered over:", countryName);
  // };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex" }}>
        <div style={{ padding: "13px" }}>
          <button
            style={{
              marginBottom: "1rem",
              width: "8rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "11px",
            }}
            onClick={toggleRegionFilter}
          >
            {" "}
            <b> {dateRangeCity}</b>
          </button>
          {isCityLeadDataOpen && (
            <div
              style={{
                position: "absolute",
                zIndex: 999,
                border: "solid 1px black",
                marginLeft: "1pc",
                width: "35pc",
                background: "white",
              }}
            >
              <DateRangePicker
                ranges={[selectionRangeCity]}
                onChange={handleSelectleadUser}
              />
              <button
                onClick={cityFilterApplyButton}
                style={{
                  marginBottom: "1rem",
                  width: "8rem",
                  height: "2.5rem",
                  borderRadius: "0.5rem",
                  fontSize: "13px",
                  position: "relative",
                  top: "1px",
                  left: "17pc",
                  backgroundColor: "#5B489D",
                  color: "White",
                  border: "none",
                }}
              >
                Apply Filter
              </button>
              <button
                style={{
                  marginBottom: "1rem",
                  width: "7.5rem",
                  height: "2.5rem",
                  borderRadius: "0.5rem",
                  fontSize: "13px",
                  position: "relative",
                  top: "1px",
                  left: "17pc",
                  color: "red",
                  backgroundColor: "white",
                  border: "none",
                  fontWeight: "bold",
                }}
                onClick={closeButtonCityData}
              >
                Close
              </button>
            </div>
          )}
        </div>
        <div
          style={{
            height: "100px",
            // overflowY: "auto",
            marginTop: "6px",
            padding: "7px 8px 0 13px",
            width: "20%",
          }}
        >
          <select
            style={{
              marginBottom: "1rem",
              width: "8rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              fontWeight: "bold",
            }}
            id="regionList"
            name="regionList"
            // value={regionListName}
            onChange={handleServiceTypeChange}
          >
            <option value=""> Service Type</option>
            <option value="International">International</option>
            <option value="Domestic">Domestic</option>
          </select>
        </div>
      </div>
      {/* <MapContainer
          style={{ height: "340px", width: "100%" }}
          center={[20, 0]}
          zoom={2}
          scrollWheelZoom={false}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution=""
          />
          <GeoJSON
            data={geoJsonData}
            style={geoJsonStyle}
            eventHandlers={{ mouseover: onCountryHover }}
          />
        </MapContainer> */}
      {/* </div> */}
      {/* <div className="container-fluid"> */}
      <div className="orderSummary">
        <table style={{ width: "100%", textAlign: "center" }}>
          <tr className="orderSummaryHeading">
            <th>City</th>
            <th>Leads</th>
            <th>Booking</th>
            <th>Execution</th>
          </tr>
          <hr className="orderSummary" />
          {cityData.map((item) => (
            <tr>
              <td className="leftAlign">{item.City}</td>
              <td>{item.Leads}</td>
              <td>{item.Booking}</td>
              <td>{item.Execution}</td>
            </tr>
          ))}
        </table>
      </div>
      {/* </div> */}
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={600}
          height={400}
          data={cityData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          barCategoryGap="20%"
          barGap="5%"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="City" />
          {/* <YAxis /> */}
          <Tooltip />
          <Legend wrapperStyle={{ color: "black" }} className="custom-legend" />
          <Bar
            style={{ color: "black" }}
            dataKey="Leads"
            fill="#04B35A"
            stackId="a"
            barSize={30}
          />
          <Bar dataKey="Booking" fill="#A7E4C5" stackId="a" barSize={30} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MapComponent;
